/* unplugin-vue-components disabled */import script from "./MemberView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MemberView.vue?vue&type=script&setup=true&lang=ts"

import "./MemberView.vue?vue&type=style&index=0&id=91ed5376&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91ed5376"]])

export default __exports__